import React from 'react';

import Header from '/react4xp/components/Header'
import Footer from '/react4xp/components/Footer'
import CoursePlan from '/react4xp/components/pages/course-plan'

import '/react4xp/shared/css/normalize.min.css'
import '/react4xp/shared/css/bootstrap-grid.min.css'
import '/react4xp/shared/css/balloon.min.css'
import '/react4xp/shared/scss/main.scss'

const StudieplanPage = (props: any) => {
    return (
        <>
            <Header {...props.headerProps} />
            <main>
                <CoursePlan
                    breadcrumbs={props.breadcrumbs}
                    dropdown={props.dropdown}
                    items={props.items}
                    pdf={{
                        label: props.pdf?.label
                    }}
                    annex={props.annex}
                    expandAllButton={props.expandAllButton}
                />
            </main>
            <Footer {...props.footerProps} />
        </>
    )
}

export default StudieplanPage;
